import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ReCAPTCHA from 'react-google-recaptcha';
import { Autocomplete, Divider, TextField, FormHelperText, CircularProgress } from '@mui/material';
import { Button } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { getData, postData } from '../../services/fetch-service';
import { useFormik } from 'formik';
import * as Yup from 'yup'
import PayseraPayment from '../PayseraPayment';
import dayjs from 'dayjs';
import { setPaymentResponse } from '../store/dataslice';
import { FaEuroSign } from "react-icons/fa";
import { LoadingOverlay, Loader } from '@mantine/core';
import Swal from 'sweetalert2';
import { animateScroll } from 'react-scroll';

const customLoader = (
    <div className="payment-load">
        <Loader color="#006" />
        <span>Në procesim...</span>
    </div>
);

const Kesco_PaymentFields = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reCaptchaRef = useRef(null);
    const [updateLoader, setUpdateLoader] = useState(false);

    const LlojiPagesesList = [
        {
            id: 977,
            emertimi: "Pagese per  KES/CO - Prishtine",
            label: "DPR",
        },
        {
            id: 978,
            emertimi: "Pagese per  KES/CO - Prizren",
            label: "DPZ",
        },
        {
            id: 979,
            emertimi: "Pagese per  KES/CO - Peje",
            label: "DPE",
        },
        {
            id: 980,
            emertimi: "Pagese per  KES/CO - Gjakove",
            label: "DGJ",
        },
        {
            id: 981,
            emertimi: "Pagese per  KES,/CO - Gjilan",
            label: "DGL",
        },
        {
            id: 982,
            emertimi: "Pagese per  KES/CO - Mitrovice",
            label: "DMI",
        },
        {
            id: 983,
            emertimi: "Pagese per  KES/CO - Ferizaj",
            label: "DFE",
        }
    ];

    const SelectedPayment = useSelector((state) => state.Website.data.PaymentSelected);
    const [selectedLlojiPageses, setSelectedLlojiPageses] = useState(null);
    const [kerkoLoading, setKerkoLoading] = useState(false);
    const [NumriSerik, setNumriSerik] = useState(null);
    const [pagesaLoading, setPagesaLoading] = useState(false);
    const [loanLoading, setLoanLoading] = useState(false);
    const [InstitucioniServiceData, setInstitucioniServiceData] = useState(null);
    const [Loan, setLoan] = useState(false);

    const fetchInstitucioniServiceData = async (token) => {
        try {
            const response = await postData('Pagesat/GetInstitucionServiceData', {
                llojipagesesID: selectedLlojiPageses.id,
                serialNumber: selectedLlojiPageses.label + NumriSerik,
                token: token
            });
            setInstitucioniServiceData(response.data.respond);
            setKerkoLoading(false);
        } catch (error) {
            setKerkoLoading(false);
            setInstitucioniServiceData(null);
            Swal.fire({
                icon: 'error',
                title: 'Gabim',
                text: "Pagesa me këtë shifër të konsumatorit nuk është gjetur!"
            });
        }
    };

    async function handleSearch() {
        reCaptchaRef.current.reset();
        try {
            setKerkoLoading(true);
            const token = await reCaptchaRef.current.executeAsync();
            fetchInstitucioniServiceData(token);
        } catch (error) {
            setKerkoLoading(true);
        }
    };

    const handleBack = () => {
        navigate('/');
    }

    const payment_validationSchema = Yup.object().shape({
        Email: Yup.string().email('Email nuk është valid!').required('Email është obligativ!'),
        ShumaFatures: Yup.number().required('Fusha është obligative!'),
    });

    const formik = useFormik({
        initialValues: {
            Email: '',
            ShumaFatures: '',
        },
        validationSchema: payment_validationSchema,
        onSubmit: (values) => {
            reCaptchaRef.current.reset();
            postPagesaPerSherbime(values)
        },
    });

    const today = new Date();
    const strDataPageses = dayjs(today).format('DD/MM/YYYY');

    const postPagesaPerSherbime = async (data) => {
        const token = await reCaptchaRef.current.executeAsync();
        try {
            setUpdateLoader(true);
            const newData = {
                ...data,
                emri: InstitucioniServiceData.consumerNameField,
                mbiemri: '/',
                institucioniId: 59,
                provizioni: 0,
                viti: `${new Date().getFullYear()}`,
                strProvizioni: '0',
                llojiPagesesID: selectedLlojiPageses.id,
                numriSerik: selectedLlojiPageses.label + NumriSerik,
                numriUnikPageses: InstitucioniServiceData.paymentReferenceField,
                strDataPageses: `${strDataPageses}`,
                strVlera: `${data.ShumaFatures}`,
                strVleraTotale: `${data.ShumaFatures}`,
                pershkrimi: 'Pagesë për Kesco',
                paymentMethod: 3,
                sherbimiTipiID: 7,
                unirefOK: false,
                token: token,
                PayWithLoan: Loan ? true : false
            }
            const response = await postData('Pagesat/PagesaPerSherbime', newData);
            if (response && response.status === 200) {
                if (!Loan) {
                    dispatch(setPaymentResponse(response.data.respond));
                    setPagesaLoading(false);
                } else {
                    setLoanLoading(false);
                    const paymentWindow = window.open('', '_self');
                    paymentWindow.location.href = `${response.data.link}`;
                }
            }
        } catch (error) {
            setPagesaLoading(false);
            setLoanLoading(false);
            setUpdateLoader(false);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `${error.response ? error.response.data.modelState.Error.errors[0].errorMessage : "Pagesa dështoi!"}`
            });
        }
    }

    const [handlePayCounter, setHandlePayCounter] = useState(0);

    useEffect(() => {
        if (formik.errors.Email && handlePayCounter === 1) {
            setHandlePayCounter(0);
            const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: `${formik.errors.Email}`
            });

            const emailInput = document.getElementById('email-input');
            if (emailInput) {
                const newPosition = emailInput.offsetTop - 300;

                animateScroll.scrollTo(newPosition, {
                    duration: 500,
                    smooth: true
                });
            }

            const emailInputTx = document.getElementById('email-input-tx');
            if (emailInputTx) {
                emailInputTx.focus();
            }

        } else if (!formik.errors.Email && formik.errors.shuma && handlePayCounter === 1) {
            setHandlePayCounter(0);
            const Toast = Swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.onmouseenter = Swal.stopTimer;
                    toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                title: `${formik.errors.shuma}`
            });

            const shumaInput = document.getElementById('shuma-input');
            if (shumaInput) {
                const newPosition = shumaInput.offsetTop - 300;

                animateScroll.scrollTo(newPosition, {
                    duration: 500,
                    smooth: true
                });
            }

            const shumaInputNr = document.getElementById('shuma-input-nr');
            if (shumaInputNr) {
                shumaInputNr.focus();
            }
        }
    }, [formik.errors.Email, handlePayCounter]);

    const handlePay = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setPagesaLoading(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
                setHandlePayCounter(prev => prev + 1);
            }
        });
    }

    const handlePayWithLoan = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setLoanLoading(true);
                setLoan(true);
                formik.handleSubmit();
            } else {
                formik.setTouched(Object.keys(formik.values).reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {}));
                setHandlePayCounter(prev => prev + 1);
            }
        });
    }

    useEffect(() => {
        if (InstitucioniServiceData && InstitucioniServiceData.totalDebtField) {
            formik.setFieldValue('ShumaFatures', InstitucioniServiceData.totalDebtField)
        }
    }, [InstitucioniServiceData])

    return (
        <div className="paysera-home paysera-feilds kesco-feilds">
            <div className="home-header">
                <h1 className='headline-font'>
                    {SelectedPayment.description}
                </h1>
            </div>
            <div className="paysera-form-body">
                <div className="form-box search-box">
                    <div className="form-body search-body">
                        <div className="paysera-form">
                            <div className="paysera-inputLabel s-Label">
                                <label htmlFor="Numri Serik">Shifra konsumatorit <span className="required">*</span></label>
                                <div className="s-input">
                                    <Autocomplete
                                        disablePortal
                                        disableClearable
                                        className='s-type'
                                        id="combo-box-demo"
                                        options={LlojiPagesesList}
                                        value={selectedLlojiPageses}
                                        onChange={(event, newValue) => {
                                            setSelectedLlojiPageses(newValue);
                                        }}
                                        // inputValue={selectedInstitucioni}
                                        sx={{ width: 300 }}
                                        size='small'
                                        // noOptionsText={LlojiPagesesList && LlojiPagesesList.length === 0 ? 'Nuk ka të dhëna' : 'Duke procesuar...' }
                                        noOptionsText={
                                            LlojiPagesesList.length === 0 &&
                                            (
                                                <div className="dropdownLoader">
                                                    <CircularProgress size={20} color="inherit" />
                                                </div>
                                            )
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label=""
                                                variant="outlined"
                                                placeholder='...'
                                                fullWidth
                                            />
                                        )}
                                    />
                                    <OutlinedInput
                                        size="small"
                                        className='s-inputSearch'
                                        id="outlined-adornment-input"
                                        placeholder="Numri njehësorit"
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                        onChange={(event) => setNumriSerik(event.target.value)}
                                        onKeyPress={(event) => {
                                            if (event.key === 'Enter' && selectedLlojiPageses !== null) {
                                                handleSearch();
                                            }
                                        }}
                                    />
                                    <Button
                                        type="button"
                                        className="dynamic-button"
                                        variant="contained"
                                        onClick={handleSearch}
                                        disabled={kerkoLoading || (selectedLlojiPageses === null)}
                                    >
                                        {kerkoLoading ? <CircularProgress size={24} /> : 'Kërko'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-box">
                    <Divider className='subheading-font' textAlign="center">Konsumatori</Divider>
                    <div className="form-body">
                        {InstitucioniServiceData ? (
                            <div className="paysera-form">
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Emri</label>
                                    <OutlinedInput
                                        disabled
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Emri Mbiemri"
                                        value={InstitucioniServiceData.consumerNameField}
                                        aria-describedby="outlined-input-helper-text"
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div className="paysera-inputLabel">
                                    <label htmlFor="Numri Serik">Adresa</label>
                                    <OutlinedInput
                                        disabled
                                        size="small"
                                        id="outlined-adornment-input"
                                        placeholder="Adresa"
                                        aria-describedby="outlined-input-helper-text"
                                        value={InstitucioniServiceData.addressField}
                                        inputProps={{
                                            'aria-label': 'input',
                                        }}
                                    />
                                </div>
                                <div id="email-input" className="paysera-inputLabel">
                                    <label className={formik.touched.Email && formik.errors.Email ? 'label-top' : ''} htmlFor="Numri Serik">Email <span className="required">*</span></label>
                                    <div className="input">
                                        <OutlinedInput
                                            size="small"
                                            id="email-input-tx"
                                            placeholder="Shëno email-in tuaj"
                                            name='Email'
                                            type="email"
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                            value={formik.values.Email}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            error={formik.touched.Email && formik.errors.Email}
                                        />
                                        {
                                            formik.touched.Email && formik.errors.Email && (
                                                <FormHelperText>{formik.errors.Email}</FormHelperText>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Fragment>
                                <div className="skeletonBox-detajet">
                                    <h4 className="skeleton-title-font" >Për të shfaqur detajet e pagesës kërkoni përmes shifrës së konsumatorit.</h4>
                                </div>
                                <div className="skeleton-btn">
                                    <Button type="button" variant="outlined" onClick={handleBack}>
                                        Kthehu
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                    {InstitucioniServiceData ? (
                        <Fragment>
                            <Divider className='subheading-font' textAlign="center">Detajet e faturës</Divider>
                            <div className="form-body">
                                <div className="paysera-form">

                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Njehsori</label>
                                        {/* amater id feild */}
                                        <OutlinedInput
                                            size="small"
                                            disabled
                                            id="outlined-adornment-input"
                                            placeholder="Njehsori"
                                            aria-describedby="outlined-input-helper-text"
                                            value={InstitucioniServiceData.ameterIdField}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>

                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Grupi tarifor</label>
                                        <OutlinedInput
                                            size="small"
                                            id="outlined-adornment-input"
                                            placeholder="Grupi tarifor"
                                            type='text'
                                            disabled
                                            value={InstitucioniServiceData.tariffGroupField}
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Nr. i referencës</label>
                                        <OutlinedInput
                                            size="small"
                                            disabled
                                            id="outlined-adornment-input"
                                            placeholder="Nr. i referencës"
                                            type='text'
                                            value={InstitucioniServiceData.paymentReferenceField}
                                            aria-describedby="outlined-input-helper-text"
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Periudha </label>
                                        <OutlinedInput
                                            size="small"
                                            disabled
                                            id="outlined-adornment-input"
                                            placeholder="Periudha"
                                            aria-describedby="outlined-input-helper-text"
                                            value={`${InstitucioniServiceData.invoicePeriodField}/${InstitucioniServiceData.invoiceYearField}`}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Fatura e fundit</label>
                                        <OutlinedInput
                                            size="small"
                                            disabled
                                            id="outlined-adornment-input"
                                            placeholder="Periudha"
                                            aria-describedby="outlined-input-helper-text"
                                            value={`${InstitucioniServiceData.invoiceAmountField} €`}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Data pageses te fundit</label>
                                        <OutlinedInput
                                            size="small"
                                            disabled
                                            id="outlined-adornment-input"
                                            placeholder="Data pageses te fundit"
                                            type='text'
                                            aria-describedby="outlined-input-helper-text"
                                            value={dayjs(InstitucioniServiceData.lastPaymentDateField).format('DD/MM/YYYY')}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>
                                    <div className="paysera-inputLabel">
                                        <label htmlFor="Numri Serik">Borxhi total</label>
                                        <OutlinedInput
                                            size="small"
                                            disabled
                                            id="outlined-adornment-input"
                                            placeholder="€"
                                            aria-describedby="outlined-input-helper-text"
                                            value={`${InstitucioniServiceData.totalDebtField} €`}
                                            inputProps={{
                                                'aria-label': 'input',
                                            }}
                                        />
                                    </div>
                                    <div id="shuma-input" className="paysera-inputLabel">
                                        <label className={formik.touched.ShumaFatures && formik.errors.ShumaFatures ? 'label-top' : ''} htmlFor="Numri Serik">Shuma e faturës <span className="required">*</span></label>
                                        <div className="input">
                                            <OutlinedInput
                                                size="small"
                                                id="shuma-input-nr"
                                                placeholder="€"
                                                type='number'
                                                endAdornment={<FaEuroSign />}
                                                className='number-input'
                                                name='ShumaFatures'
                                                aria-describedby="outlined-input-helper-text"
                                                inputProps={{
                                                    'aria-label': 'input',
                                                    // inputMode: 'numeric'
                                                }}
                                                value={formik.values.ShumaFatures}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.ShumaFatures && formik.errors.ShumaFatures}
                                            />
                                            {
                                                formik.touched.ShumaFatures && formik.errors.ShumaFatures && (
                                                    <FormHelperText>{formik.errors.ShumaFatures}</FormHelperText>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="p-buttons">
                                        <div className="payForm-btn">
                                            <Button type="button" variant="outlined" onClick={handleBack}>
                                                Kthehu
                                            </Button>
                                            <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePayWithLoan}
                                                // disabled
                                                disabled={loanLoading}
                                                startIcon={loanLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {loanLoading ? 'Loading...' : 'Paguaj përmes kredisë'}
                                            </Button>
                                            <Button
                                                id="payNow"
                                                type="button"
                                                variant="contained"
                                                onClick={handlePay}
                                                disabled={pagesaLoading}
                                                startIcon={pagesaLoading && <CircularProgress size={20} color="inherit" />}
                                            >
                                                {pagesaLoading ? 'Duke paguar...' : 'Paguaj'}
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        ''
                    )}
                </div>
            </div>
            <ReCAPTCHA
                badge="bottomleft"
                sitekey={process.env.REACT_APP_SITE_KEY}
                size="invisible"
                ref={reCaptchaRef}
            />
            <PayseraPayment />
            <LoadingOverlay loader={customLoader} visible={updateLoader} />
        </div >
    )
}

export default Kesco_PaymentFields